//import Vue from 'vue'
import Vuex from 'vuex'
import DataLoading from './modules/Dataloading.js'
import CSFCLoading from './modules/CSFCloading.js'
import Channel from './modules/Channel.js'
import User from './modules/User.js'
import menu from './modules/Menu.js'

Vue.use(Vuex)
// root modules
const modules =  {
    DataLoading,
    CSFCLoading,
    Channel,
    User,
    menu
};

// root state
const state = {
    lat: window.localStorage.getItem('lat'),
    lng: window.localStorage.getItem('lng'),
    city: {
        code: window.localStorage.getItem('code'),
        name: window.localStorage.getItem('name'),
    },
    // 用户选择的城市信息
    selectCity : JSON.parse(window.localStorage.getItem('selectCity')),
    ha: {
        code: window.localStorage.getItem('hacode'),
        name: window.localStorage.getItem('haname'),
    },
    // api 请求列表
    apiLoadingList:[],
    selectData: '',
    propType: {
        11: '住宅',
        22: '商铺',
        21: '办公'
    },
    face: {
        1: '南向',
        10: '南北',
        2: '东向',
        3: '西向',
        4: '北向',
        5: '东南',
        6: '东北',
        7: '西南',
        8: '西北',
        9: '东西'
    },
    intDeco: {
        1: '毛坯房',
        2: '未装修',
        3: '局部装修',
        4: '简单装修',
        5: '精装修',
        6: '豪华装修'
    },
    indoStru: {
        11: '平层',
        12: '错层',
        13: '复式',
        14: '阁楼',
        18: '跃层'
    },
    bldgType: {
        11: '多层',
        12: '小高层',
        13: '高层',
        20: '平房',
        21: '别墅',
        22: '联体别墅'
    }
};

// root getters
const getters = {
    apiLoadingList: (state) => state.apiLoadingList,
    getValueById: (state) => (type, id) => state[type][id],
    getCity: (state) => state.city,
    getSelectCity: (state)=> (type) => {
        if (!state.selectCity) return '';
        if (type) return state.selectCity[type] || '';
        return state.selectCity;
    },
    // 获取最终城市信息
    getFinalCity: (state, getters) => (type = null) => {
        // 1、先读selectCity
        if (state.selectCity) {
            return getters.getSelectCity(type);
        }
        // 2、再读city字段
        if (state.city) {
            if (type) return state.city[type] || '';
            return state.city;
        }
        // 如果都没有，返回null
        return null;
    },
    getSelectData: (state) => state.selectData,
    getLng: (state) => state.lng,
    getLat: (state) => state.lat,
    getPoint: (state) => {
        if(state.pointname && state.lng && state.lat){
            return state.pointname+','+state.lng + ',' + state.lat;
        } else {
            return '';
        }
    },
    getLocation: (state) => {
        if (state.lng && state.lat) {
            return state.lng + ',' + state.lat;
        } else {
            return '';
        }
    },
    //统计PV页面
    statistics: () => (path) => {
        if (process.env.NODE_ENV != 'production') return;
        if (!window._hmt) return;
        window._hmt.push(['_trackPageview', path]);
    },
    //统计事件
    trackEvent: (state, getters) => (category, action, opt_label) => {
        if (process.env.NODE_ENV != 'production') return;
        //if (!getters.getSourceSwitch('statistics')) return;
        if (!window._hmt) return;
        let cityCode = getters.getSelectCity('code') || getters.getCity.code;
        let _category = `${cityCode}_${category}`;
        window._hmt.push(['_trackEvent', _category, action, opt_label]);
    },
};
// root mutations
const mutations = {
    updateApiLoadingList: (state, api) => {
        if (api >= 0) {
            state.apiLoadingList.push(api);
        } else if (state.apiLoadingList.length>0) {
            state.apiLoadingList.splice(0,1);
        }
    },
    updateLocation: (state, options) => {
        state.pointname = options.pointname;
        state.lat = options.lat;
        state.lng = options.lng;
        window.localStorage.setItem('pointname', options.pointname);
        window.localStorage.setItem('lat', options.lat);
        window.localStorage.setItem('lng', options.lng);
    },
    updateCity: (state, {code, name}) =>{
        state.city = {code, name};
        window.localStorage.setItem('code', code);
        window.localStorage.setItem('name', name);
    },
    updateSelectCity: (state, data) => {
        state.selectCity = {...data};
        window.localStorage.setItem('selectCity', JSON.stringify(data));
    },
    updateHa: (state, {code, name}) =>{
        state.ha = {code, name};
        window.localStorage.setItem('hacode', code);
        window.localStorage.setItem('haname', name);
    },
    updateSelectData: (state, data) => {
        state.selectData = data;
    },
};
// root actions
const actions = {
    updateApiLoadingList: ({commit}, api) =>{
        commit('updateApiLoadingList', api);
    },
    updateLocation: ({commit}, options) =>{
        commit('updateLocation', options);
    },
    updateCity: ({commit}, options) => {
        commit('updateCity', options);
    },
    updateSelectCity: ({commit}, options) => {
        commit('updateSelectCity', options);
    },
    updateSelectData: ({commit}, options) => {
        commit('updateSelectData', options);
    },
};

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules
});
export default store



// WEBPACK FOOTER //
// ./src/store/index.js